var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"centerx"},[_c('lottie',{attrs:{"options":_vm.errorOptions,"height":500,"width":500}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }